'use client';

import { builder } from '@builder.io/sdk';
import { RenderBuilderContent } from 'components/builder';
import { useEffect, useState } from 'react';

export default function MarqueeBuilder({ isScrolled }: { isScrolled: boolean }) {
  const [marqueeBanner, setMarqueeBanner] = useState(null);

  useEffect(() => {
    const fetchMarqueeBanner = async () => {
      const content = await builder.get('symbol', {
        query: {
          name: 'MarqueeBanner'
        }
      });
      setMarqueeBanner(content);
    };

    fetchMarqueeBanner();
  }, []);

  return (
    <>
      <div
        className={`fixed left-0 right-0 top-0 z-50 min-h-[49px] w-full bg-fp-green ${isScrolled ? '!invisible' : ''}`}
        id="marquee-banner"
      >
        {marqueeBanner && <RenderBuilderContent content={marqueeBanner} model="symbol" />}
      </div>
    </>
  );
}
